import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import Util from '../../util.js';
import { getTradeDetail , historyConfirmDetail, superfundCancelFun} from '../../action/investmentAction';
import NavigatorMain from '../NavigatorMain';
import { Toast } from 'antd-mobile/lib';
import Password from '../myAssets/payment/Password'

let getDateYM = Util.returnDate;


/*智投交易记录详情*/
class TransactionDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSouse:[],
      list:{
        list_item1:{
          key:[]
        },
        list_item1:{
          key:[]
        }
      },
      pwdFlag: false,
      keyPasswordVal: ""
    };
  }
  componentWillMount(){
    document.getElementsByTagName('title')[0].innerHTML = "交易详情";
    let { dispatch } = this.props;
    let data = this.props.location.state.data;
    let flag = this.props.location.state.flag ? this.props.location.state.flag : null;
    if(flag === "QR"){
      dispatch(historyConfirmDetail(data,this.detailCallBack.bind(this),this))
    }else{  
      dispatch(getTradeDetail(data,this.detailCallBack.bind(this),this))
    }
  }
  detailCallBack(data){
    let list = {};
    if(data.businessType === "T020" || data.businessType === "T022"){ /*认购 申购 超级基金申购*/
      list ={
        list_item1:{
          title:data.businessTypeName,
          key:['name1','name2','name3','name4','name5','name6','name7','name8','name9','name10','name11','name12','name13'],
          name1:['产品名称', data.fundName],
          name2:['资金渠道',data.trustChannelName],
          name3:['支付渠道',Util.formatStr(data.bankName) !="--" ? Util.formatStr(data.bankName) + " ****" + data.bankAccountShowNo.substr(data.bankAccountShowNo.length - 4 ) : Util.formatStr(data.bankName)],
          name4:['申请编号',data.tradeRequestId],
          name5:['收费方式',data.fundShareClassName],
          name6:['下单日期',getDateYM(data.businessTime)],
          name7:['下单时间',getDateHS(data.businessTime)],
          name8:['所属交易日',getDateYM(data.requestWorkday)],
          name9:['申请金额',Util.fomatFloat(data.applicationAmount) === "--" ? Util.fomatFloat(data.applicationAmount) : Util.fomatFloat(data.applicationAmount) + "元"],
          name10:['确认金额',Util.fomatFloat(data.confirmAmount) === "--" ? Util.fomatFloat(data.confirmAmount) : Util.fomatFloat(data.confirmAmount) + "元"],
          name11:['结算币种',Util.formatStr(data.currencyName)],
          name12:['交易状态',data.businessStateName],
          name13:['确认结果',Util.formatStr(data.taConfirmStateName)],
        },
        list_item2:{
          key:[],
        }
      }
      if(data.hasOwnProperty("commission")) {
        list.list_item1.name13 = ['交易费用',this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--" ];
        list.list_item1.name14 = ['确认结果',Util.formatStr(data.taConfirmStateName)];
        list.list_item1.key.push("name14");
      }
    }else if(data.businessType === "T220"){ /*赎回转认购*/
      list ={
        list_item1:{
          title:data.businessTypeName,
          key:['name1','name2','name3','name4','name5','name6','name7','name8','name9','name10','name11','name12','name13','name14'],
          name1:['产品名称', Util.formatStr(data.targetFundName)],
          name2:['资金渠道',data.trustChannelName],
          name3:['支付渠道',Util.formatStr(data.bankName) !="--" ? Util.formatStr(data.bankName) + " ****" + data.bankAccountShowNo.substr(data.bankAccountShowNo.length - 4 ) : Util.formatStr(data.bankName)],
          name4:['申请编号',data.tradeRequestId],
          name5:['收费方式',data.targetFundShareClassName],
          name6:['下单日期',getDateYM(data.businessTime)],
          name7:['下单时间',getDateHS(data.businessTime)],
          name8:['所属交易日',getDateYM(data.requestWorkday)],
          name9:['支付方式',Util.formatStr(data.fundName)],
          name10:['申请金额',Util.fomatFloat(data.applicationAmount) === "--" ? Util.fomatFloat(data.applicationAmount) : Util.fomatFloat(data.applicationAmount) + "元"],
          name11:['确认金额',Util.fomatFloat(data.confirmAmount) === "--" ? Util.fomatFloat(data.confirmAmount) : Util.fomatFloat(data.confirmAmount) + "元"],
          name12:['结算币种',Util.formatStr(data.currencyName)],
          name13:['交易状态',data.businessStateName],
          name14:['确认结果',Util.formatStr(data.taConfirmStateName)],
        },
        list_item2:{
          key:[],
        }
      }
      if(data.hasOwnProperty("commission")) {
        list.list_item1.name14 = ['交易费用',this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--" ];
        list.list_item1.name15 = ['确认结果',Util.formatStr(data.taConfirmStateName)];
        list.list_item1.key.push("name15");
      }
    }else if(data.businessType === "T522"){/*超级基金申购*/
          list ={
            list_item1:{
              title:data.businessTypeName,
              key:['name1','name2','name3','name4',/*'name5',*/'name6','name7','name8','name9','name10','name11','name12','name13'],
              name1:['产品名称', Util.formatStr(data.targetFundName)],
              name2:['资金渠道',data.trustChannelName],
              name3:['支付渠道',Util.formatStr(data.bankName) !="--" ? Util.formatStr(data.bankName) + " ****" + data.bankAccountShowNo.substr(data.bankAccountShowNo.length - 4 ) : Util.formatStr(data.bankName)],
              name4:['申请编号',data.tradeRequestId],
              /*name5:['支付方式',""],*/
              name6:['下单日期',getDateYM(data.businessTime)],
              name7:['下单时间',getDateHS(data.businessTime)],
              name8:['所属交易日',getDateYM(data.requestWorkday)],
              name9:['申请金额',Util.fomatFloat(data.applicationAmount) === "--" ? Util.fomatFloat(data.applicationAmount) : Util.fomatFloat(data.applicationAmount) + "元"],
              name10:['确认金额',Util.fomatFloat(data.confirmAmount) === "--" ? Util.fomatFloat(data.confirmAmount) : Util.fomatFloat(data.confirmAmount) + "元"],
              name11:['结算币种',Util.formatStr(data.currencyName)],
              name12:['交易状态',data.businessStateName],
              name13:['确认结果',Util.formatStr(data.taConfirmStateName)],
            },
            list_item2:{
              key:[],
            }
          }
          if(data.hasOwnProperty("commission")) {
            list.list_item1.name13 = ['交易费用',this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--" ];
            list.list_item1.name14 = ['确认结果',Util.formatStr(data.taConfirmStateName)];
            list.list_item1.key.push("name14");
          }
    }else if(data.businessType === "T822"){/*超级基金申购*/
          list ={
            list_item1:{
              title:data.businessTypeName,
              key:['name1','name2','name3','name4','name5','name6','name7','name8','name9','name10','name11','name12','name13','name14','name15'],
              name1:['客户名称',data.tradeAccountName],
              name2:['业务类别',Util.formatStr(data.businessTypeName)],
              name3:['产品名称',data.targetFundName],
              name4:['资金渠道',data.trustChannelName],
              name5:['申请编号',data.tradeRequestId],
              name6:['收费方式',data.targetFundShareClassName],
              name7:['下单日期',getDateYM(data.businessTime)],
              name8:['下单时间',getDateHS(data.businessTime)],
              name9:['所属交易日',getDateYM(data.requestWorkday)],
              name10:['支付方式',Util.formatStr(data.fundName)],
              name11:['申请金额',Util.fomatFloat(data.applicationAmount) === "--" ? Util.fomatFloat(data.applicationAmount) : Util.fomatFloat(data.applicationAmount) + "元"],
              name12:['确认金额',Util.fomatFloat(data.confirmAmount) === "--" ? Util.fomatFloat(data.confirmAmount) : Util.fomatFloat(data.confirmAmount) + "元"],
              name13:['结算币种',Util.formatStr(data.currencyName)],
              name14:['交易状态',data.businessStateName],
              name15:['确认结果',Util.formatStr(data.taConfirmStateName)],
            },
            list_item2:{
              key:[],
            }
          }
          if(data.hasOwnProperty("commission")) {
            list.list_item1.name15 = ['交易费用',this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--" ];
            list.list_item1.name16 = ['确认结果',Util.formatStr(data.taConfirmStateName)];
            list.list_item1.key.push("name16");
          }
    }else if(data.businessType==='E224'||data.businessType==='E225'||data.businessType==='E226'||data.businessType==='E205'||data.businessType==='E204'||data.businessType==='E206'){/*定投通  */
      list={
        list_item1:{
          title:data.businessTypeName,
          key:['name1','name2','name3','name4','name5','name6','name7','name8','name9','name10','name12','name13','name14',,'name15','name16'],
          name1:['产品名称',data.targetFundName],
          name2:['资金渠道',data.trustChannelName],
          name3:['支付渠道',data.trustChannelName],
          name4:['基金账号',Util.formatStr(data.taAccountNo)],
          name5:['申请编号',Util.formatStr(data.tradeRequestId)],
          name6:['协议号',Util.formatStr(data.tradePlanId)],
          name7:['收费方式',Util.formatStr(data.targetFundShareClassName) == "--" ? Util.formatStr(data.fundShareClassName) : Util.formatStr(data.targetFundShareClassName)],
          name8:['下单日期',getDateYM(data.businessTime)],
          name9:['下单时间',getDateHS(data.businessTime)],
          name10:['所属交易日',getDateYM(data.requestWorkday)],
          /*name11:['支付时间',Util.formatStr(data.paymentTime)],*/
          name12:['申请金额',data.applicationAmount != null ? data.applicationAmount + "元" : "--"],
          name13:['结算币种',"人民币"],
          name14:['风险标志',Util.formatStr(data.riskRearingControlFlagName)],
          name15:['交易状态',Util.formatStr(data.businessStateName)],
          name16:['确认结果',Util.formatStr(data.taConfirmStateName)],
        },
        list_item2:{
          key:[],
        }
      }
      if(data.hasOwnProperty("commission")) {
        list.list_item1.name16 = ['交易费用',this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--" ];
        list.list_item1.name17 = ['确认结果',Util.formatStr(data.taConfirmStateName)];
        list.list_item1.key.push("name17");
      }
      /**************确认详情*******/
    }
    else if(data.businessType === "T024"){ /*赎回 */
      list={
        list_item1:{
          title:data.businessTypeName,
          key:['name1','name2','name3','name4','name5','name6','name7','name8','name9','name10','name11','name12','name13','name14'],
          name1:['产品名称',data.fundName],
          name2:['托管渠道',data.trustChannelName],
          name3:['收款账户',Util.formatStr(data.bankName) !="--" ? Util.formatStr(data.bankName) + " ****" + data.bankAccountShowNo.substr(data.bankAccountShowNo.length - 4 ) : Util.formatStr(data.bankName)],
          name4:['申请编号',data.tradeRequestId],
          name5:['收费方式',data.fundShareClassName],
          name6:['下单日期',getDateYM(data.businessTime)],
          name7:['下单时间',getDateHS(data.businessTime)],
          name8:['所属交易日',getDateYM(data.requestWorkday)],
          name9:['申请金额',Util.fomatFloat(data.applicationAmount) == "--" ? Util.fomatFloat(data.applicationAmount) : Util.fomatFloat(data.applicationAmount) + '元'],
          name10:['申请份额',Util.formatStr(data.applicationVolume) == "--" ? Util.formatStr(data.applicationVolume) : Util.formatStr(data.applicationVolume) + "份"],
          name11:['确认金额',Util.fomatFloat(data.confirmAmount) === "--" ? Util.fomatFloat(data.confirmAmount) : Util.fomatFloat(data.confirmAmount) + "元"],
          name12:['结算币种',Util.formatStr(data.currencyName)],
          name13:['巨额赎回处理',data.largeRedemptionName],
          name14:['确认结果',Util.formatStr(data.businessStateName)],
        },
        list_item2:{
          key:[],
        }
      }
      if(data.hasOwnProperty("commission")) {
        list.list_item1.name14 = ['交易费用',this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--" ];
        list.list_item1.name15 = ['确认结果',Util.formatStr(data.businessStateName)];
        list.list_item1.key.push("name15");
      }
    }else if(data.businessType === "T422" || data.businessType === "T420" ){/*外部赎回转申购/认购 */
      list={
        list_item1:{
          title:data.businessTypeName,
          key:['name1','name2',/*'name3'*/,'name4','name5','name6','name7','name8','name9','name10','name11','name12','name13','name14'],
          name1:['产品名称',data.targetFundName],
          name2:['托管渠道',data.trustChannelName],
          /*name3:['收款账户',Util.formatStr(data.bankName) !="--" ? Util.formatStr(data.bankName) + " ****" + data.bankAccountShowNo.substr(data.bankAccountShowNo.length - 4 ) : Util.formatStr(data.bankName) ],*/
          name4:['申请编号',data.tradeRequestId],
          name5:['收费方式',data.targetFundShareClassName],
          name6:['下单日期',getDateYM(data.businessTime)],
          name7:['下单时间',getDateHS(data.businessTime)],
          name8:['所属交易日',getDateYM(data.requestWorkday)],
          name9:['支付方式',"活期通"],
          name10:['申请金额',Util.fomatFloat(data.applicationAmount) == "--" ? Util.fomatFloat(data.applicationAmount) : Util.fomatFloat(data.applicationAmount) + "元"],
          /*name11:['申请份额',Util.formatStr(data.applicationVolume) == "--" ? Util.formatStr(data.applicationVolume) : Util.formatStr(data.applicationVolume) + "份"],*/
          name11:['确认金额',Util.fomatFloat(data.confirmAmount) === "--" ? Util.fomatFloat(data.confirmAmount) : Util.fomatFloat(data.confirmAmount) + "元"],
          name12:['结算币种',Util.formatStr(data.currencyName)],
          name13:['交易状态',Util.formatStr(data.businessStateName)],
          name14:['确认结果',Util.formatStr(data.taConfirmStateName)],
        },
        list_item2:{
          key:[],
        }
      }
      if(data.hasOwnProperty("commission")) {
        list.list_item1.name14 = ['交易费用',this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--" ];
        list.list_item1.name15 = ['确认结果',Util.formatStr(data.taConfirmStateName)];
        list.list_item1.key.push("name15");
      }
    }else if(data.businessType === "T036"){/*转换*/
      list={
        list_item1:{
          title:data.businessTypeName,
          key:['name1','name2','name3','name4','name5','name6','name7','name8','name9','name10','name11','name12','name13'],
          name1:['转出基金名称',data.fundName],
          name2:['转出基金收费方式',Util.formatStr(data.fundShareClassName)],
          name3:['托管渠道',data.trustChannelName],
          name4:['转入基金名称',data.targetFundName],
          name5:['转入基金收费方式',Util.formatStr(data.targetFundShareClassName)],
          name6:['申请编号',Util.formatStr(data.tradeRequestId)],
          name7:['下单日期',getDateYM(data.businessTime)],
          name8:['下单时间',getDateHS(data.businessTime)],
          name9:['所属交易日',getDateYM(data.requestWorkday)],
          name10:['申请份额',Util.formatStr(data.applicationVolume) == "--" ? Util.formatStr(data.applicationVolume) : Util.formatStr(data.applicationVolume) + "份"],
          name11:['结算币种',Util.formatStr(data.currencyName)],
          name12:['交易状态',Util.formatStr(data.businessStateName)],
          name13:['确认结果',Util.formatStr(data.taConfirmStateName)],
        },
        list_item2:{
          key:[],
        }
      }
      if(data.hasOwnProperty("commission")) {
        list.list_item1.name13 = ['交易费用',this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--" ];
        list.list_item1.name14 = ['确认结果',Util.formatStr(data.taConfirmStateName)];
        list.list_item1.key.push("name14");
      }
    }else if(data.businessType === "T999"){/*调仓 */
      list={
        list_item1:{
          title:data.businessTypeName,
          key:['name1','name2','name3','name4','name5','name6','name7','name8','name9','name10','name11','name12'],
          name1:['产品名称',data.fundName],
          name2:['托管渠道',data.trustChannelName],
          name3:['申请编号',Util.formatStr(data.tradeRequestId)],
          name4:['下单日期',getDateYM(data.businessTime)],
          name5:['下单时间',getDateHS(data.businessTime)],
          name6:['所属交易日',getDateYM(data.requestWorkday)],
          name7:['申请份额',"--"],
          name8:['申请金额',Util.fomatFloat(data.applicationAmount) == "--" ? Util.fomatFloat(data.applicationAmount) : Util.fomatFloat(data.applicationAmount) + "元" ],
          name9:['确认金额',Util.fomatFloat(data.confirmAmount) === "--" ? Util.fomatFloat(data.confirmAmount) : Util.fomatFloat(data.confirmAmount) + "元"],
          name10:['结算币种',Util.formatStr(data.currencyName)],
          name11:['交易状态',Util.formatStr(data.businessStateName)],
          name12:['确认结果',Util.formatStr(data.taConfirmStateName)],
        },
        list_item2:{
          key:[],
        }
      }
      if(data.hasOwnProperty("commission")) {
        list.list_item1.name12 = ['交易费用',this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--" ];
        list.list_item1.name13 = ['确认结果',Util.formatStr(data.taConfirmStateName)];
        list.list_item1.key.push("name13");
      }
    }else if(data.businessType === "T029"){/*修改分红方式 */
      list={
        list_item1:{
          title:data.businessTypeName,
          key:['name1','name2','name3','name4','name5','name6'],
          name1:['产品名称',data.fundName],
          name2:['申请编号',Util.formatStr(data.tradeRequestId)],
          name3:['下单日期',getDateYM(data.businessTime)],
          name4:['下单时间',getDateHS(data.businessTime)],
          name5:['所属交易日',getDateYM(data.requestWorkday)],
          name6:['确认结果',Util.formatStr(data.taConfirmStateName)],
        },
        list_item2:{
          key:[],
        }
      }
      if(data.hasOwnProperty("commission")) {
        list.list_item1.name6 = ['交易费用',this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--" ];
        list.list_item1.name7 = ['确认结果',Util.formatStr(data.taConfirmStateName)];
        list.list_item1.key.push("name7");
      }
    }else if(data.businessType === "T039" || data.businessType === "E201" || data.businessType === "E202" || data.businessType === "E203" || data.businessType === "E227" || data.businessType === "E228" || data.businessType === "E229"){/*定投通  */
      list={
        list_item1:{
          title:data.businessTypeName,
          key:['name1','name2','name3','name4','name5','name6','name7','name8','name9','name10','name12','name13','name14',,'name15','name16'],
          name1:['产品名称',data.fundName],
          name2:['资金渠道',data.trustChannelName],
          name3:['支付渠道',Util.formatStr(data.bankName) !="--" ? Util.formatStr(data.bankName) + " ****" + data.bankAccountShowNo.substr(data.bankAccountShowNo.length - 4 ) : Util.formatStr(data.bankName)],
          name4:['基金账号',Util.formatStr(data.taAccountNo)],
          name5:['申请编号',Util.formatStr(data.tradeRequestId)],
          name6:['协议号',Util.formatStr(data.tradePlanId)],
          name7:['收费方式',Util.formatStr(data.targetFundShareClassName) == "--" ? Util.formatStr(data.fundShareClassName) : Util.formatStr(data.targetFundShareClassName)],
          name8:['下单日期',getDateYM(data.businessTime)],
          name9:['下单时间',getDateHS(data.businessTime)],
          name10:['所属交易日',getDateYM(data.requestWorkday)],
          /*name11:['支付时间',Util.formatStr(data.paymentTime)],*/
          name12:['申请金额',data.applicationAmount != null ? data.applicationAmount + "元" : "--"],
          name13:['结算币种',"人民币"],
          name14:['风险标志',Util.formatStr(data.riskRearingControlFlagName)],
          name15:['交易状态',Util.formatStr(data.businessStateName)],
          name16:['确认结果',Util.formatStr(data.taConfirmStateName)],
        },
        list_item2:{
          key:[],
        }
      }
      if(data.hasOwnProperty("commission")) {
        list.list_item1.name16 = ['交易费用',this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--" ];
        list.list_item1.name17 = ['确认结果',Util.formatStr(data.taConfirmStateName)];
        list.list_item1.key.push("name17");
      }
      /**************确认详情*******/
    }else if(data.businessType === "T130" || data.businessType === "T122" || data.businessType === "T192" || data.businessType === "T139"){
      list={
        list_item1:{
          title:data.businessTypeName,
          key:['name1','name2','name3','name4','name5','name6','name7','name8','name9','name10','name11','name12'],
          name1:['产品名称',data.fundName],
          name2:['成交净值',Util.newToFixed(data.confirmNav,4)],
          name3:['支付渠道',Util.formatStr(data.capitalChannelName) !="--" ? Util.formatStr(data.capitalChannelName) + " ****" + data.currentAccountNo.substr(data.currentAccountNo.length - 4 ) : Util.formatStr(data.capitalChannelName)],
          name4:['申请编号',Util.formatStr(data.tradeRequestId)],
          name5:['确认编号',Util.formatStr(data.tradeConfirmNo)],
          name6:['收费方式',Util.formatStr(data.fundShareClassName)],
          name7:['申请日期',getDateYM(data.requestWorkday)],
          name8:['确认日期',getDateYM(data.confirmWorkday)],
          name9:['交易确定金额',data.confirmAmount != null ? data.confirmAmount + "元" : "--"],
          name10:['交易确定份额',data.confirmVolume != null ? data.confirmVolume + "份" : "--"],
          name11:['交易费用',data.commision != null ? data.commision + "元" : "--" ],
          name12:['确认结果',Util.formatStr(data.taConfirmStateName)],
        },
        list_item2:{
          key:[],
        }
      }
    }else if(data.businessType === "T124" || data.businessType === "T194 " || data.businessType === "T142"){
      list={
        list_item1:{
          title:data.businessTypeName,
          key:['name1','name2','name3','name4','name5','name6','name7','name8','name9','name10','name11','name12','name13'],
          name1:['产品名称',data.fundName],
          name2:['成交净值',Util.newToFixed(data.confirmNav,4)],
          name3:['托管渠道',Util.formatStr(data.capitalChannelName)],
          name4:['收款账户',Util.formatStr(data.returnBankName) !="--" ? Util.formatStr(data.returnBankName) + " ****" + data.returnBankAccountShowNo.substr(data.returnBankAccountShowNo.length - 4 ) : Util.formatStr(data.returnBankName)],
          name5:['申请编号',Util.formatStr(data.tradeRequestId)],
          name6:['确认编号',Util.formatStr(data.tradeConfirmNo)],
          name7:['收费方式',Util.formatStr(data.fundShareClassName)],
          name8:['申请日期',getDateYM(data.requestWorkday)],
          name9:['确认日期',getDateYM(data.confirmWorkday)],
          name10:['交易确定金额',data.confirmAmount != null ? data.confirmAmount + "元" : "--"],
          name11:['交易确定份额',data.confirmVolume != null ? data.confirmVolume + "份" : "--"],
          name12:['交易费用',data.commision != null ? data.commision + "元" : "--" ],
          name13:['确认结果',Util.formatStr(data.taConfirmStateName)],
        },
        list_item2:{
          key:[],
        }
      }
    }else if(data.businessType === "T120"){
      list={
        list_item1:{
          title:data.businessTypeName,
          key:['name1','name2','name3','name4','name5','name6','name7','name8','name9','name10'],
          name1:['产品名称',data.fundName],
          name2:['成交净值',Util.newToFixed(data.confirmNav,4)],
          name3:['支付渠道',Util.formatStr(data.capitalChannelName) !="--" ? Util.formatStr(data.capitalChannelName) + " ****" + data.currentAccountNo.substr(data.currentAccountNo.length - 4 ) : Util.formatStr(data.capitalChannelName)],
          name4:['申请编号',Util.formatStr(data.tradeRequestId)],
          name5:['确认编号',Util.formatStr(data.tradeConfirmNo)],
          name6:['收费方式',Util.formatStr(data.fundShareClassName)],
          name7:['申请日期',getDateYM(data.requestWorkday)],
          name8:['确认日期',getDateYM(data.confirmWorkday)],
          name9:['交易确定金额',data.confirmAmount != null ? data.confirmAmount + "元" : "--"],
          name10:['确认结果',Util.formatStr(data.taConfirmStateName)],
        },
        list_item2:{
          key:[],
        }
      }
      if(data.hasOwnProperty("commission")) {
        list.list_item1.name10 = ['交易费用',this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--" ];
        list.list_item1.name11 = ['确认结果',Util.formatStr(data.taConfirmStateName)];
        list.list_item1.key.push("name11");
      }
    }else if(data.businessType === "T136"){
      let flag = this.props.location.state.flag ? this.props.location.state.flag : null;
      if(flag == "QR") {
        list={
          list_item1:{
            title:data.businessTypeName,
            key:['name1','name2','name3','name4','name5','name6','name7','name8','name9','name10','name11','name12','name13','name14'],
            name1:['转出基金名称',data.fundName],
            name2:['转出基金收费方式',Util.formatStr(data.fundShareClassName)],
            name3:['托管渠道',Util.formatStr(data.capitalChannelName)],
            name4:['转入基金名称',Util.formatStr(data.targetFundName)],
            name5:['转入基金收费方式',Util.formatStr(data.targetFundShareClassName)],
            name6:['申请编号',Util.formatStr(data.tradeRequestId)],
            name7:['确认编号',Util.formatStr(data.tradeConfirmNo)],
            name8:['申请日期',getDateYM(data.requestWorkday)],
            name9:['确认日期',getDateYM(data.confirmWorkday)],
            name10:['交易确定份额',data.confirmVolume != null ? data.confirmVolume + "份" : "--" ],
            name11:['转入基金净值',Util.newToFixed(data.targetFundNav,4)],
            name12:['转出基金净值',Util.newToFixed(data.confirmNav,4)],
            name13:['交易费用',data.commision != null ? data.commision + "元" : "--" ],
            name14:['确认结果',Util.formatStr(data.taConfirmStateName)],
          },
          list_item2:{
            key:[],
          }
        }
      }else {
        list={
          list_item1:{
            title:data.businessTypeName,
            key:['name1','name2','name3','name4','name5','name6','name7','name8','name9','name10','name11','name12'],
            name1:['转出基金名称',data.fundName],
            name2:['转出基金收费方式',Util.formatStr(data.fundShareClassName)],
            name3:['托管渠道',Util.formatStr(data.capitalChannelName)],
            name4:['转入基金名称',Util.formatStr(data.targetFundName)],
            name5:['转入基金收费方式',Util.formatStr(data.targetFundShareClassName)],
            name6:['申请编号',Util.formatStr(data.tradeRequestId)],
            name7:['确认编号',Util.formatStr(data.tradeConfirmNo)],
            name8:['申请日期',getDateYM(data.requestWorkday)],
            name9:['确认日期',getDateYM(data.confirmWorkday)],
            name10:['交易确定份额',data.confirmVolume != null ? data.confirmVolume + "份" : "--" ],
            name11:['交易费用',data.commision != null ? data.commision + "元" : "--" ],
            name12:['确认结果',Util.formatStr(data.taConfirmStateName)],
          },
          list_item2:{
            key:[],
          }
        }
      }
    }else if(data.businessType === "T129"){
      list={
        list_item1:{
          title:data.businessTypeName,
          key:['name1','name2','name3','name4','name5'],
          name1:['申请编号',Util.formatStr(data.tradeRequestId)],
          name2:['确认编号',Util.formatStr(data.tradeConfirmNo)],
          name3:['申请日期',getDateYM(data.requestWorkday)],
          name4:['确认日期',getDateYM(data.confirmWorkday)],
          name5:['确认结果',Util.formatStr(data.taConfirmStateName)],
        },
        list_item2:{
          key:[],
        }
      }
      if(data.hasOwnProperty("commission")) {
        list.list_item1.name5 = ['交易费用',this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--" ];
        list.list_item1.name6 = ['确认结果',Util.formatStr(data.taConfirmStateName)];
        list.list_item1.key.push("name6");
      }
    }else{
      list={
        list_item1:{
          title:data.businessTypeName,
          key:['name1','name2','name3','name4','name5','name6','name7','name8','name9','name10','name12','name13','name14',,'name15','name16'],
          name1:['产品名称',data.targetFundName],
          name2:['资金渠道',data.trustChannelName],
          name3:['支付渠道',data.trustChannelName],
          name4:['基金账号',Util.formatStr(data.taAccountNo)],
          name5:['申请编号',Util.formatStr(data.tradeRequestId)],
          name6:['协议号',Util.formatStr(data.tradePlanId)],
          name7:['收费方式',Util.formatStr(data.targetFundShareClassName) == "--" ? Util.formatStr(data.fundShareClassName) : Util.formatStr(data.targetFundShareClassName)],
          name8:['下单日期',getDateYM(data.businessTime)],
          name9:['下单时间',getDateHS(data.businessTime)],
          name10:['所属交易日',getDateYM(data.requestWorkday)],
          /*name11:['支付时间',Util.formatStr(data.paymentTime)],*/
          name12:['申请金额',data.applicationAmount != null ? data.applicationAmount + "元" : "--"],
          name13:['结算币种',"人民币"],
          name14:['风险标志',Util.formatStr(data.riskRearingControlFlagName)],
          name15:['交易状态',Util.formatStr(data.businessStateName)],
          name16:['确认结果',Util.formatStr(data.taConfirmStateName)],
        },
        list_item2:{
          key:[],
        }
      }
      if(data.hasOwnProperty("commission")) {
        list.list_item1.name16 = ['交易费用',this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--" ];
        list.list_item1.name17 = ['确认结果',Util.formatStr(data.taConfirmStateName)];
        list.list_item1.key.push("name17");
      }
    }


    this.setState({
      list:list,
      dataSouse:data
    })
  } 
  ProtocolPaper(){
    hashHistory.push({
        pathname:'/Transfer',
        state:{name:'调整组合',type:1},
        query: {code:''}
    })
  }

  goBack(){
    // hashHistory.push({
    //     pathname:'/TransactionRecord',
    // })
    hashHistory.go(-1)
  }         
  chechan(){
    this.setState({
      pwdFlag: true
    });
  }
  keyOk = () => {
    const pushResult = (i,result) => {
      Toast.hide();
      if (i===1) {
          this.setState({
            pwdFlag: false
          });
          hashHistory.push({
            pathname:'/Success',
            state: {
              title:'撤回结果',
              content:'申请已受理',
              dataSouse:[['申请编号',this.state.dataSouse.businessType == "E231" ? this.props.location.state.data.tradeRequestId : result.content],['产品名称',this.state.dataSouse.businessType === "T522" ? Util.formatStr(this.state.dataSouse.targetFundName) : this.state.dataSouse.fundName],['所属交易日',getDateYM(this.state.dataSouse.requestWorkday)]],
              souseVal:['返回我的智投']

            }
          });
      } else if (i===3) {
          hashHistory.push({
            pathname:'/ErrorResult',
            state: {
              title:'撤回',
              content:'撤回失败',
              content2:result,
              dataSouse:[],
              souseVal:['返回华夏智投','联系客服']
            }
          });
      }
    }  
    Toast.loading();
    const data = this.props.location.state.data;
    data.password = Util.encrypt(this.state.keyPasswordVal);
    this.props.dispatch(superfundCancelFun(data, pushResult, () => {
      Toast.hide();
    }));
  }
  onChangePwd = (val) => {
    this.setState({
      keyPasswordVal:val
    })
  }
  render() {
    let data = this.props.getTradeDetail;
 
        let list_item1Temp = {
          title:"华夏智投银行申购",
          key:['name1','name2','name3','name4','name5','name6','name7','name8','name9','name10','name11','name12'],
          name1:['转出基金名称',"常青大学计划"],
          name2:['转出基金收费方式',"收费方式"],
          name3:['托管渠道',"托管渠道"],
          name4:['转入基金名称',"转入基金名称"],
          name5:['转入基金收费方式',"转入基金收费方式"],
          name6:['申请编号',"申请编号"],
          name7:['确认编号',"确认编号"],
          name8:['申请日期',"2017-07-28"],
          name9:['确认日期',"2017-07-28"],
          name10:['交易确定份额',"100份"],
          name11:['交易费用',"0.00"],
          name12:['确认结果',"成功"],
        }
    let list = this.state.list;
    let list_item1 = list.list_item1;
    let { dataSouse } = this.state;

    return (
        <div className="container">
          <NavigatorMain>
          <div className="header black">
            <div ><span className="headerLeftBtn" onClick={ ()=> this.goBack() }></span></div>
            <div >交易详情</div>
            <div ></div>    
          </div>
          </NavigatorMain>
          <div className=" content">
          {
              list_item1.key.length > 0 ?
                <div style={{width:"100%"}}>
                    <div style={{ padding:'0.44rem 13px 0.24rem 13px'}}>
                        <span style={{ color:'#fa063a' }}>{ list_item1.title }</span>
                    </div>
                    {
                      list_item1.key.map(function(item,i){
                        return(
                            <div className="TransactionDetailList" key = { i }>
                              <span>{list_item1[item][0]}</span><span>{ list_item1[item][1] }</span>
                            </div>
                        )
                      })
                    }
                </div>: null
          } 
         

          {/*
            <div style={{ padding:'0.44rem 13px 0.24rem 13px'}}>
              <span style={{ color:'#fa063a' }}>华夏智投银行申购</span>
            </div>
            <div className="TransactionDetailList">
              <span>产品名称</span><span>常青大学计划</span>
            </div>
            <div className="TransactionDetailList">
              <span>产品名称</span><span>常青大学计划</span>
            </div>
            <div className="TransactionDetailList">
              <span>产品名称</span><span>常青大学计划</span>
            </div>
          */}
            </div>
            {
              this.state.dataSouse.isCancel && 
              // dataSouse.businessType != "T020" && 
              dataSouse.businessType != "T420" && 
              // dataSouse.businessType != "T422" && 
              dataSouse.businessType != "T999" &&
              dataSouse.businessType != "TH20" &&
              dataSouse.businessType != "E233" &&
              dataSouse.businessType != "E234" &&
              dataSouse.businessType != "E235" ?
              <div className="isCancel_botton" onClick={()=>this.chechan()}>
                <span className="isCancel_img"></span>
                <span style={{ fontSize: 12, color:"#5b6370" }}>撤单</span>
              </div> : null
          }
          {
            this.state.pwdFlag?
            <Password _this={this} ztFlag={true} _type="ZT"/>
            :null
          }  
        </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    getTradeDetail:state.getTradeDetail
  }
}

export default connect(mapStateToProps)(TransactionDetail);

function getDateHS(vue){
  let num = Number(vue)
  var resultDate,year,month,date,hms;
  var currDate = new Date(num);
  year = currDate.getFullYear();
  month = currDate.getMonth()+1;
  date = currDate.getDate();
  let hs = currDate.getHours();
  let ms = currDate.getMinutes();
  let ss =  currDate.getSeconds();
  hs = (hs < 10) ? ('0' + hs) : hs;
  ms = (ms < 10) ? ('0' + ms) : ms;
  ss = (ss < 10) ? ('0' + ss) : ss;
  month = (month < 10) ? ('0' + month) : month;
  date = (date < 10) ? ('0' + date) : date;
  hms = hs + ':' + ms + ":" + ss;
  resultDate = hms;
  return resultDate;
}




// WEBPACK FOOTER //
// ./src/components/fundDetail/TransactionDetail.js